import React from 'react'
import {Heading, Timer} from '@myxplor/ui'
import {FormSubmit} from '@myxplor/forms'
import {IS_EMBEDDED} from '../../embedded'

const done = () => {
  if (!IS_EMBEDDED) {
    window.parent.location = '/'
  }
}

const AuthPeopleDone = ({person}) => {
  return (
    <form 
      className="onboarding--done"
      onSubmit={(e) => {
        e.preventDefault()
        done()
      }}>
      <Timer secs={5} done={done}>
        You will be redirected to the homepage
      </Timer>


      <Heading>
        All done
      </Heading>
      <p>
        You have set <span className="authorised-person__name">
          {person.first_name} {person.last_name} 
        </span> as your authorised person
      </p>


      <FormSubmit>
          Done
      </FormSubmit>
    </form>
  )
}

export default AuthPeopleDone


// WEBPACK FOOTER //
// ./src/auth-personnel/views/done.jsx